import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { myroutes } from "../../routes/webroute";
import { Button } from "react-bootstrap";
import Modal from 'react-bootstrap/Modal';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import PanierService from "../../services/PanierService";
import { useSelector, useDispatch } from 'react-redux';
import { incrementNbrePanier, resetCart } from "../../app/providers/panierSlice";
import Badge from 'react-bootstrap/Badge';
import { logoutRequest } from "../../backend/auth/logout";
import { resetAuthData } from "../../app/providers/authSlice";
import Swal from "sweetalert2";
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';



export default function Header(props) {
    const test = useSelector((state) => state.panier.countPanier);
    const location = useLocation();
    const pathname = location.pathname;
    const dispatch = useDispatch();
    const [show, setShow] = useState(false);
    const auth = useSelector(state => state.auth)
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const nbrePublication = localStorage.getItem('nbrePanier');
    const [isScrolled, setIsScrolled] = useState(false);


    const updatePanier = async () => {
        //console.log("################## test panier ###############")
        try {
            await PanierService.index().then(({ data }) => {
               // console.log(data)
            }).catch(({ response }) => {
               // console.log(response)
            });
        } catch (error) {
            console.log(error);
        }
    }

    // se déconnecter
	const handleLogout = () => {    
		logoutRequest(auth.token);
		dispatch(resetAuthData());
        dispatch(resetCart());
        Swal.fire({
            icon: "success",
                    title: 'Vous vous êtes déconnectée avec succès',
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    background: "green",
                    color: "white",
                    iconColor: "white"
          });
	}


    useEffect(() => {
        updatePanier();
    }, []);

    useEffect(() => {
        const handleScroll = () => {
          setIsScrolled(window.pageYOffset > 0);
        };
      
        window.addEventListener('scroll', handleScroll);
      
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
      }, []);
      


    return (
        <React.Fragment>
            <div className="container-fluid position-relative p-0 " >
            <nav className="navbar navbar-expand-lg navbar-dark px-5 py-3 py-lg-0">
        
        <Link to={ myroutes.homepage } className="navbar-brand  p-0">
         <h1 className="text-primary m-0" style={{fontWeight: "500", fontSize:"26px" }}><img src="../startup/img/logo-digiweb2.png" alt="logo-blanc" style={{height: "65px" }}/> DGBOOK</h1>
        </Link>

         <button className="navbar-toggler1" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
          <span className="fa fa-bars"></span>
           </button>
          <div className="collapse navbar-collapse" id="navbarCollapse">
            <div className="navbar-nav ms-auto py-0">

            <Link
          to={myroutes.homepage} className={`nav-item nav-link ${pathname === myroutes.homepage ? "active" : ""}`} >
          Accueil
        </Link>
        <Link
          to={myroutes.catalogue} className={`nav-item nav-link ${pathname === myroutes.catalogue ? "active" : ""}`} >
          Catalogue
        </Link>
        
        <Link  to={myroutes.comment_ca_marche} className={`nav-item nav-link ${ pathname === myroutes.comment_ca_marche ? "active" : ""}`}>
          Comment ça marche ?
        </Link>
        <Link to={myroutes.contact} className={`nav-item nav-link ${pathname === myroutes.contact ? "active" : "" }`} >
          Contact
        </Link>
          </div>

          {auth.isAuthenticate ? 
                            ( 
                            <>
                         <div className="d-flex align-items-center d-lg-none d-xl-none"> {/* Conteneur parent avec alignement en ligne */}

                             {auth.roles.includes("USER") && auth.roles.includes("ADMIN") ? (
                                // Si l'utilisateur a les deux rôles ("USER" et "ADMIN")
                                <>
                                <DropdownButton variant="outline-warning" className="bouton me-3 d-lg-none d-xl-none" id="dropdown-basic-button" style={{zIndex: 999999}} title="Mon compte">
                                <Dropdown.Item href={myroutes.dashboard}><i className="fa fa-th-large me-2"></i>Tableau de bord</Dropdown.Item>
                                <Dropdown.Item href={myroutes.moncompte}><i className="fa fa-th-large me-2"></i>Mon compte utilisateur</Dropdown.Item>
                                </DropdownButton>
                                    
                                </>
                            ) : auth.roles.includes("USER") ? (

                                // Si l'utilisateur a uniquement le rôle "USER"
                                <Link to={myroutes.moncompte}>
                                    <Button variant="outline-warning" className="bouton me-3">
                                        <i className="fa fa-th-large me-2"></i>Mon compte
                                    </Button>
                                </Link>
                            ) : (
                                // Si l'utilisateur a uniquement le rôle "ADMIN" 
                                <Link to={myroutes.dashboard}>
                                    <Button variant="outline-warning" className="bouton me-3">
                                        <i className="fa fa-th-large me-2"></i>Tableau de bord
                                    </Button>
                                </Link>
                            )}
                                <Button
                                    variant="warning"
                                    onClick={handleLogout}
                                >
                                    <i className="fa fa-stop me-2 "></i>Se déconnecter
                                </Button>
                                </div>
                            </>
                        ) : (
                        <>
                        <Button  className="btn  bg-warning me-3  d-lg-none d-xl-none" onClick={handleShow}><i className="fa fa-user-plus me-2"></i>S'inscrire</Button>
                        <Link to={myroutes.login}  className="btn  bg-primary d-lg-none d-xl-none" style={{color:"white"}}><i className="fa fa-lock me-2 "></i>Se connecter</Link>

                        </>
                    )}

                    <Button type="button" className="btn  bg-primary text-white ms-3" data-bs-toggle="modal" data-bs-target="#searchModal"><i className="fa fa-search" ></i></Button>
                    <Link to={myroutes.monpanier} title="voir le panier pour plus de détails" className="btn btn-primary py-2 px-4 m-4 ms-3"> <i className="fas fa-shopping-cart me-2"></i> Panier <Badge bg="white text-black">{test}</Badge></Link>

        </div>
    </nav>

                <Modal show={show} onHide={handleClose} centered className="custom-modal">
                    <Modal.Header closeButton>

                        <Modal.Title className="mx-auto me-3 "> Type d'utilisateur</Modal.Title>

                    </Modal.Header>

                    <Modal.Body>
                        <Container>

                            <Row>
                                <Col xs={8} md={6}>
                                    <Button href="/inscriptions/particulier" variant="primary" style={{ padding: "22px", borderRadius: "4px", marginBottom: "10px" }}>Je suis un particulier</Button>{' '}
                                </Col>
                                <Col xs={8} md={6}>
                                    <Button href="/inscriptions/entreprise" variant="warning" style={{ padding: "22px", borderRadius: "4px" }}>Je suis une entreprise</Button>{' '}
                                </Col>

                            </Row>
                        </Container>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="dark" onClick={handleClose} className="mx-auto">
                            Fermer
                        </Button>
                    </Modal.Footer>
                </Modal>

                <div id="header-carousel" className="carousel slide carousel-fade" data-bs-ride="carousel">
                    <div className="carousel-inner">
                        <div className="carousel-item active">
                            <img className="w-100" src="../startup/img/bg2.png" alt="Image" />
                            <div className="carousel-caption d-flex flex-column align-items-center justify-content-center">
                                <div className="p-3" style={{ minWidth: "1200px" }}>
                                    <h1 className="text-header text-white mb-md-4 animated zoomIn ">DGBook,</h1>
                                    <h1 className="text-header text-white mb-md-4 animated zoomIn ">Ventes d’ouvrages et périodiques</h1>
                                    <p className="text-header2 text-white mb-mt-3 animated slideInDown ">Librairie numérique, d’économie et de gestion !</p>
                                    <Link to={myroutes.comment_ca_marche} className="btn btn-primary py-md-3 px-md-5 me-3 mt-4 animated slideInLeft">
                                        Comment ça marche ?
                                    </Link>
                                    <Link to={myroutes.contact} className="btn btn-warning py-md-3 px-md-5 me-3 mt-4 animated slideInLeft">
                                        Contactez-nous
                                    </Link> 
                                </div>
                            </div>
                        </div>
                        <div className="carousel-item">
                            <img className="w-100" src="../startup/img/bg1.png" alt="Image" />
                            <div className="carousel-caption d-flex flex-column align-items-center justify-content-center">
                                <div className="p-3" style={{ minWidth: "1100px" }}>
                                    <h1 className="text-header text-white mb-md-4 animated zoomIn">DGBook,</h1>
                                    <h1 className="text-header text-white mb-md-4 animated zoomIn">Ventes d’ouvrages et périodiques</h1>
                                    <p className="text-header2 text-white  mb-mt-3 animated slideInDown"> Trouvez en un clic le livre et la périodique que vous recherchez !</p>
                                    <Link className="btn btn-primary py-md-3 px-md-5 me-3 mt-4 animated slideInLeft">
                                        Comment ça marche ?
                                    </Link>
                                    <Link className="btn btn-warning py-md-3 px-md-5 me-3 mt-4 animated slideInLeft">
                                        Contactez-nous
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <span className="carousel-control-prev" type="button" data-bs-target="#header-carousel"
                        data-bs-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Previous</span>
                    </span>
                    <span className="carousel-control-next" type="button" data-bs-target="#header-carousel"
                        data-bs-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Next</span>
                    </span>
                </div>
            </div>
        </React.Fragment>
    )
}